import * as React from "react";
import Component from "../../../AbstractComponent";

export class NewCoachBody extends Component {

  constructor(public props) {
    super(props);
  }

  public render() {
    const { children } = this.props;
    return (
      <div id="step-content" className={`step-content-wrapper step-scrollable-content unit-coach wide-coach`}>
        {children}
      </div>
    );
  }
}
